<template>
  <div class="signin-card">
    <p class="signin-card_title">
      {{ title }}
    </p>
    <div class="signin-card_content">
      <slot />
    </div>
    <div class="signin-card_bottom-btns">
      <slot name="bottom-btns" />
    </div>
  </div>
</template>
<script>
export default {
  name: "SigninCard",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default() {
        return this.$t("歡迎回來ESGoal");
      },
    },
    isloading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  methods: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/component/signin-card";
</style>